import {setFetching} from '../../../helpers'

export default {
  setConfigData(state, data) {
    state.data = data
  },
  setChrome(state){
    state.chromeless = false
  },
  removeChrome(state){
    state.chromeless = true
  },
  setFetching
}



// WEBPACK FOOTER //
// ./src/store/modules/config/mutations.js